import React, { FunctionComponent } from 'react';
import { FormikHelpers, Field } from 'formik';
import { FieldInputProps } from 'formik/dist/types';
import { Money } from '@/models/money';
import { TextField, TextFieldProps } from '@mui/material';

type MoneyInputProps = {
    form: FormikHelpers<Money>;
    field: FieldInputProps<Money>;
    errors: { [k: string]: string };
} & TextFieldProps;

const MoneyInput: FunctionComponent<
    React.PropsWithChildren<MoneyInputProps>
> = ({ field, form, errors, ...props }) => {
    const { name, value } = field;
    const { setFieldValue } = form;
    return (
        <TextField
            {...field}
            {...props}
            type='number'
            value={value?.amount || ''}
            onChange={(e) => {
                setFieldValue(name, {
                    amount: parseFloat(e.target.value),
                    currency: 'EUR',
                });
            }}
            error={!!errors[name]}
            helperText={errors[name] ? errors[name] : ''}
        />
    );
};

type MoneyInputFieldProps = {
    name: string;
} & TextFieldProps;

export const MoneyInputField: FunctionComponent<
    React.PropsWithChildren<MoneyInputFieldProps>
> = ({ name, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form }) => (
                <MoneyInput
                    field={field}
                    form={form}
                    errors={form.errors}
                    {...props}
                />
            )}
        </Field>
    );
};
